// GENERATED — do not edit. Imports the iconNode from the sibling .data.ts (lucide ISC).

import { createIcon } from "../../../internal/createIcon";
import { iconNode } from "./ClockIcon.data";

export const ClockIcon = createIcon("ClockIcon", iconNode);
